import React from 'react';
import { createRoot } from 'react-dom/client';

// Inter (variable) for our base type. Loaded first so subsequent rules win.
import '@fontsource-variable/inter';
// Bootstrap CSS, then our design tokens which override Bootstrap CSS variables.
import 'bootstrap/dist/css/bootstrap.min.css';
// react-datepicker ships a light-only stylesheet; our datepicker.css below
// overrides the bits that need to follow the theme.
import 'react-datepicker/dist/react-datepicker.css';
import './styles/tokens.css';
import './styles/datepicker.css';
import './index.css';
import App from './App';
import { ThemeProvider } from './theme/ThemeContext';

import { Amplify } from 'aws-amplify';
// Gen 2 emits amplify_outputs.json (generated by `ampx`); the Amplify v6
// library accepts it directly. During the Gen 1 -> Gen 2 migration this file
// is a committed placeholder pointing at the dev backend and is overwritten by
// the Gen 2 build. (Legacy src/amplifyconfiguration.json is kept until the Gen
// 1 decommission; see scripts/MIGRATION_RUNBOOK.md.)
import amplifyconfig from './amplify_outputs.json';
Amplify.configure(amplifyconfig);

const root = createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);

